export default __webpack_public_path__ + "static/linkedconnect-17f75ba5ac2d4edb551815f726beee2b.png";